import { useNavigationBlocker } from '@frontend/settings-routing';

export const useUnsavedChanges = (
  changesExist: boolean,
  show: boolean,
  openModal: () => void,
  allowedRoutePattern?: RegExp
) => {
  return useNavigationBlocker(
    {
      // this fires when the user tries to navigate away through the browser (back button, new url, etc.)
      shouldBlockFn: ({ next }) => {
        const shouldAllow = !!allowedRoutePattern?.test(next.pathname);
        if (!shouldAllow && (changesExist || show)) {
          openModal();
          return true;
        }

        return false;
      },
      // this is to block navigation for the reload or close tab/browser button
      enableBeforeUnload: changesExist,
    },
    [changesExist, show]
  );
};
